import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { GetAccess } from "../../../../Components/Utils/roles";
import { useFormik } from "formik";
import {
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo, {
  SelectProductWithError,
} from "../../../../Components/Utils/Select";
import * as yup from "yup";
import ContractLayout from "./ContractLayout";
import ViewIcon from "../../../../Components/Icons/ViewIcon";
import { Modal } from "antd";
import UseGetDataSearchlist from "../../../../Components/Hooks/useFetchDataByListing";
import ViewEquipmentsContract from "./EquipmentView";
import EquipmentmobCard from "../../../Mobile/ClientManage/Contract/MobileEquipmentIndex";
import DropDownAddMetaData, { DropDownAddUnitWithError } from "../../../../Components/Utils/selectAddMetaData";
import { NuInput, NuInputWithError } from "../../../../Components/Utils/Input";
import UsecatEquipDD from "../../../../Components/Hooks/UseCatEquipDD";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import axiosInstance from "../../../../Services/axiosCommon";
import EditIcon from "../../../../Components/Icons/Edit";
import DeleteIcon from "../../../../Components/Icons/Delete";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import ImportFileModal from "../../../../Components/Utils/ImportFileComponent";
import { formatDate } from "../../../../Components/Utils/NuDate";
import CloseIcon from "../../../../Components/Icons/Close";
import useEditFormData from "../../../../Components/Hooks/useEditFormData";
import { useToast } from "../../../../Components/Others/ToastServices";
import Pagination from "../../../../Components/Utils/Pagenation";

function Equipments() {
  const toast = useToast();
  const { contractsViewId, id } = useParams();
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);

  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [searchequipment, setSearchequipment] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [searcheCat, setSearcheCat] = useState("");
  const { Oncancel, addFormData, isLoading } = useAddFormData();
  const { editFormData } = useEditFormData();
  const [showPopupCat, setShowPopupCat] = useState(false);

  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20
  );

  const [categories, setCategories] = useState([]);
  const [editequipmentName, setEditequipmentName] = useState(null);

  const { value: unit, getData: refunit } = useFetchMataData(
    "/dropdown/dropdown-details/",
    "unit_equipments"
  );

  const [params, setParams] = useState({
    contractId: contractsViewId,
    category: "",
    search: searchQuery || "",
    page: page,
    per_page: pageCount,
  });

  const { data, getData, totalCount, dataLoading } = UseGetDataSearchlist(
    `/equipment-details/equipments-enhanced`,
    params
  );

  const [refreshData, setRefreshData] = useState(0);
  const refreshEquipmentData = () => {
    setRefreshData((prev) => prev + 1);
  };

  // Fetch categories on component mount
  useEffect(() => {
    fetchCategories();
  }, []);

  // Fetch equipment data when refreshData changes
  useEffect(() => {
    getData();
  }, [refreshData]);

  //  const displayItem = data;

  const fetchCategories = async () => {
    try {
      const response = await axiosInstance.get("/categories/");
      if (Array.isArray(response.data.data)) {
        const formatted = response.data.data.map((item) => ({
          value: item.name,
          label: item.name,
        }));
        setCategories(formatted);
      } else {
        console.error("Unexpected API response format");
        setCategories([]);
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
      setCategories([]);
    }
  };

  const { value: Equipment, getData: refEquipment } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Contract_Equip"
    );

  // Get equipment options based on selected category
  const { data: equipmentOptions, setData: setEquipmentOptions } =
    UsecatEquipDD("/equipments/drop-down", searchequipment, selectedCategoryId);

  // Formik for creating equipment
  const formik = useFormik({
    initialValues: {
      equipmentName: "",
      unit: "",
      quantity: "",
      category: "",
    },
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      category: yup.string().required("Category is required!"),
      equipmentName: yup.string().required("Equipment is required!"),
      unit: yup.string().required("Unit is required!"),
      quantity: yup
        .number()
        .required("Quantity is required!")
        .min(1, "Quantity must be at least 1"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const newValue = { ...values, contractId: contractsViewId };
      const success = await addFormData({
        url: `/equipment-details/create-equipment`,
        formData: newValue,
        resetForm,
        hasClose: true,
        CloseFun: () => {
          setShowCreateDialog(false); // close only the popup
          refreshEquipmentData(); // refresh list
        },
      });
    },
  });

  // Formik for editing equipment
  const Editformik = useFormik({
    initialValues: {
      id: "",
      equipmentName: "",
      unit: "",
      quantity: "",
      category: "",
    },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: yup.object({
      category: yup.string().required("Category is required!"),
      equipmentName: yup.string().required("Equipment is required!"),
      unit: yup.string().required("Unit is required!"),
      quantity: yup
        .number()
        .required("Quantity is required!")
        .min(1, "Quantity must be at least 1"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const editData = {
        equipmentName: values.equipmentName,
        unit: values.unit,
        quantity: values.quantity,
        category: values.category,
        contractId: contractsViewId,
      };

      const success = await editFormData({
        url: `/equipment-details/edit-equipment/${values.id}`,
        formData: editData,
        navigateUrl: `/Contract-management/contracts/equipments/${contractsViewId}`,
        resetForm,
      });

      setShowEditDialog(false);
      // resetForm();
      // refreshEquipmentData();
      getData();
    },
  });

  const closeCreateDialog = () => {
    setShowCreateDialog(false);
    formik.resetForm();
  };

  const closeEditDialog = () => {
    setShowEditDialog(false);
    Editformik.resetForm();
    setEditequipmentName(null);
  };

  const [viewModalData, setViewModalData] = useState(null);

  const openViewModal = (data) => {
    setViewModalData(data);
    setIsViewModalOpen(true);
  };

  const openEditModal = async (data) => {
    try {
      // Fetch the specific equipment details
      const response = await axiosInstance.get(
        `/equipment-details/equipment/${data.id}`
      );
      const equipmentData = response.data.data;

      // Set the form values
      Editformik.setValues({
        id: equipmentData.id,
        equipmentName: equipmentData.equipmentName,
        unit: equipmentData.unit,
        quantity: equipmentData.quantity,
        categoryId: equipmentData.categoryId,
      });

      setEditequipmentName(equipmentData.id);
      setShowEditDialog(true);
    } catch (error) {
      console.error("Error fetching equipment details:", error);
    }
  };

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const togglePopupCat = () => {
    setShowPopupCat(!showPopupCat);
  };

  const [showPopupEquipment, setShowPopupEquipment] = useState(false);

  const togglePopupEqupiment = () => {
    setShowPopupEquipment(!showPopupEquipment);
  };

  const resetFormE = () => {
    formik.values.name = "";
    setShowPopupEquipment(false);
  };

  const resetFormCat = () => {
    formik.values.name = "";
    setShowPopupCat(false);
  };

  const handlePopupSubmitCat = async (e) => {
    e.preventDefault();

    try {
      const response = await axiosInstance.post("/categories/new-category", {
        name: formik.values.name,
      });

      // Refresh categories
      fetchCategories();

      const createdcat = response.data?.data;
      setCategories((prevCat) => [
        {
          label: formik.values.name || "-",
          value: createdcat.id || createdcat,
        },
        ...prevCat,
      ]);
      resetFormCat();
    } catch (error) {
      console.error("Error creating new category:", error);
    }
  };

  const handlePopupSubmitEquipmt = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append(
      "json_data",
      JSON.stringify({
        name: formik.values.name || "",
        categoryId: formik.values.categoryId || "",
      })
    );

    try {
      const response = await axiosInstance.post(
        "/equipments/new-equipment",
        formData
      );

      const createdEquipt = response.data?.data;

      setEquipmentOptions((prevEquipments) => [
        {
          label: formik.values.name || "-",
          value: createdEquipt.id || createdEquipt,
        },
        ...prevEquipments,
      ]);
      resetFormE();
    } catch (error) {
      console.error("Error creating new equipment:", error);
    }
  };

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteConfirm(true);
  };

  const cancelDelete = () => {
    setShowDeleteConfirm(false);
    setDeleteId(null);
  };

  const confirmDelete = async () => {
    try {
      let res = await axiosInstance.delete(
        `/equipment-details/delete-equipment/${deleteId}`
      );
      if (res.data.status === true) {
        toast.open({
          type: "success",
          message: "Success",
          description: res.data?.msg || "Data Deleted Successfully.",
        });
      } else {
        toast.open({
          type: "warning",
          message: "Failed",
          description: res.data?.msg || "Error deleting equipment.",
        });
      }

      refreshEquipmentData(); // refresh list
    } catch (error) {
      console.error("Error deleting equipment:", error);
      toast.open({
        type: "error",
        message: "Error",
        description: error.response?.data?.msg || "Error deleting equipment.",
      });
    } finally {
      setShowDeleteConfirm(false);
      setDeleteId(null);
    }
  };

  const filteredCategories = categories.filter((item) =>
    item.label.toLowerCase().includes(searcheCat.toLowerCase())
  );
  const [showImportModal, setShowImportModal] = useState(false);

  const [showExport, setShowExport] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };

  const [exportValue, setExportValue] = useState({
    status: "",
  });
  const ExportFormik = useFormik({
    enableReinitialize: true,
    initialValues: exportValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      try {
        const response = await axiosInstance.get(
          `/clients/export?status=${value.status}`,
          {
            responseType: "blob",
          }
        );

        console.log("API Response:", response);

        const pdfBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(pdfBlob);
        // link.download = `Client Report ${NuDateFormate({
        //   value: new Date(),
        //   format: "DD-MMM-YYYY",
        // })}.xlsx`;

        link.download = `Client Report ${formatDate(new Date())}.xlsx`;

        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
      } catch (error) {
        console.error("Error downloading the PDF:", error);
      }
    },
  });
  const closeFilterDialogebox = () => {
    setShowExport(false);
  };

  return (
    <>
      <ContractLayout
        BackAccess={GetAccess("")}
        newCreate={true}
        setCreateOpen={setShowCreateDialog}
        setEditOpen={setShowEditDialog}
        ImportAccess={GetAccess("equipment_import")}
        // ExportAccess={GetAccess("equipment_export")}
        setOpen={setShowImportModal}
        // setOpenExport={setShowExport}
      >
        {screenSize.width < "768" ? (
          <>
            <div className="w-full h-[calc(100vh-175px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden">
              <EquipmentmobCard
                data={Array.isArray(data) ? data : data?.data || []}
                getData={getData}
              />
            </div>
          </>
        ) : (
          <>
            <div className="mt-0.5 rounded-md bg-white h-[calc(100vh-160px)] flex flex-col">
              {/* Table wrapper with scrollable tbody */}
              <div className="flex-1 overflow-y-auto">
                <table className="min-w-full text-xs text-left border-collapse">
                  <thead className="sticky top-0 bg-white z-10">
                    <tr className="text-black font-semibold border-b border-gray-300">
                      <th className="px-4 py-2 w-[5%]">SL No.</th>
                      <th className="px-4 py-2 w-[25%]">Equipment</th>
                      <th className="px-4 py-2 w-[15%]">Category</th>
                      <th className="px-4 py-2 w-[20%]">Unit</th>
                      <th className="px-4 py-2 w-[20%]">Quantity</th>
                      <th className="px-4 py-2 w-[5%]">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(Array.isArray(data) ? data : data?.data || []).map(
                      (item, i) => (
                        <tr key={item.id || i}>
                          <td className="px-4 py-2">
                            <Link
                              to={`/Contract-management/contracts/equipments/${contractsViewId}/details/${item.id}`}
                              state={{
                                data: item,
                                from: `/Contract-management/contracts/equipments/${contractsViewId}`,
                              }}
                            >
                              {item.sno || i + 1}
                            </Link>
                          </td>
                          <td className="px-4 py-2">
                            <Link
                              to={`/Contract-management/contracts/equipments/${contractsViewId}/details/${item.id}`}
                              state={{
                                data: item,
                                from: `/Contract-management/contracts/equipments/${contractsViewId}`,
                              }}
                            >
                              {item.equipmentName || "-"}
                            </Link>
                          </td>
                          <td className="px-4 py-2">{item.category || "-"}</td>
                          <td className="px-4 py-2">{item.unit || "-"}</td>
                          <td className="px-4 py-2">
                            {item.display_qty || "-"}
                          </td>
                          <td className="px-4 py-2 flex gap-2 text-gray-500">
                            <Link
                              to={`/Contract-management/contracts/equipments/${contractsViewId}/details/${item.id}`}
                              state={{
                                data: data,
                                from: `/Contract-management/contracts/equipments/${contractsViewId}`,
                              }}
                            >
                              <ViewIcon color="#048178" height={14} />
                            </Link>
                            <button onClick={() => openEditModal(item)}>
                              <EditIcon color="#048178" height={14} />
                            </button>
                            <button
                              onClick={() => handleDeleteClick(item.id)}
                              type="button"
                              className="text-red-500 cursor-pointer border-none"
                            >
                              <DeleteIcon color="red" height={14} />
                            </button>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>

              {/* Fixed Pagination */}
              <div className="border-t border-gray-200 bg-white sticky bottom-0">
                <div className="py-2 px-4">
                  <Pagination
                    total={data?.total_items || 0}
                    pageIndex={params?.page || 1}
                    setPageIndex={setPage}
                    dataCount={params?.per_page || 0}
                    setDataCount={setPageCount}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </ContractLayout>

      {showCreateDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[40%] min-h-[51vh] max-h-[51vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Create Equipment</h2>
            <form onSubmit={formik.handleSubmit}>
              <div className=" grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <DropDownAddUnitWithError
                  type="text"
                  label="Equipment"
                  placeholder="Equipment"
                  Options={Equipment}
                  formik={formik}
                  name="equipmentName"
                  width="w-full z-9"
                  px="0"
                  // handleClick={togglePopupEqupiment}
                  setSearch={setSearchequipment}
                  FixPosition={true}
                  PortalTarget={false}
                  disabled={false}
                   getFunc={refEquipment}
              displayProperty={"Equipment"}
              propertyName={"Contract_Equip"}
                />

                <SelectProductWithError
                  type="text"
                  label="Category"
                  placeholder="Category"
                  Options={filteredCategories}
                  formik={formik}
                  name="category"
                  width="w-full z-10"
                  px="0"
                  handleClick={togglePopupCat}
                  setSearch={setSearcheCat}
                  FixPosition={true}
                  PortalTarget={false}
                />

                <DropDownAddUnitWithError
                  label="Unit"
                  placeholder="Choose"
                  Options={unit}
                  formik={formik}
                  name="unit"
                  width="w-full  z-9"
                  getFunc={refunit}
                  displayProperty={"Add Unit"}
                  propertyName={"unit_equipments"}
                  FixPosition={true}
                  PortalTarget={false}
                  px="0"
                />
                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={formik}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full  z-9"
                  px="0"
                />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeCreateDialog} />
                <SubmitButton name="Submit" isLoading={isLoading} />
              </div>
            </form>
          </div>
        </div>
      )}

      {showEditDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[40%] min-h-[51vh] max-h-[51vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Edit Equipment</h2>
            <form onSubmit={Editformik.handleSubmit}>
              <div className=" grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <FormikSelectTwo
                  Options={Equipment}
                  label="Equipment"
                  placeholder="Choose"
                  formik={Editformik}
                  name="equipmentName"
                  width="w-full "
                  px="0"
                />

                <FormikSelectTwo
                  Options={filteredCategories}
                  label="Category"
                  placeholder="Choose"
                  formik={Editformik}
                  name="category"
                  width="w-full "
                  px="0"
                />

                <FormikSelectTwo
                  Options={unit}
                  label="Unit"
                  placeholder="Choose"
                  formik={Editformik}
                  name="unit"
                  width="w-full -mt-2 "
                  px="0"
                />

                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={Editformik}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full"
                  px="0"
                />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeEditDialog} />
                <SubmitButton isLoading={isLoading} />
              </div>
            </form>
          </div>
        </div>
      )}

      {isViewModalOpen && (
        <Modal
          open={isViewModalOpen}
          onCancel={() => setIsViewModalOpen(false)}
          title={"View Equipment"}
          width="50%"
          centered
          className="my-modal"
          footer={[]}
        >
          <ViewEquipmentsContract
            data={viewModalData}
            open={isViewModalOpen}
            onCancel={() => setIsViewModalOpen(false)}
          />
        </Modal>
      )}

      {showPopupEquipment && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-normal text-[12px]">Add Equipment</h2>
            <form onSubmit={handlePopupSubmitEquipmt}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  label="Name"
                  placeholder="Name"
                  formik={formik}
                  name="name"
                  width="w-full"
                  new_width="w-full"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopupEqupiment}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                                          rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showImportModal && (
        <ImportFileModal
          additional_details_req={true}
          url="/equipment-details/import-sample-file/con-equipment"
          required_columns={["Name", "Category", "Unit", "Quantity"]}
          show={showImportModal}
          onClose={closeModal}
          apiUrl={`/equipment-details/import-equipment/${contractsViewId}`}
          menuName="Equipment"
          getData={getData}
        />
      )}
      {showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[85%]  sm:min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                    <FormikSelectTwo
                      label="Status"
                      placeholder="Choose"
                      Options={[]}
                      formik={ExportFormik}
                      name="status"
                      width="w-full"
                    />
                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                  <SubmitButton name="Export" />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
      {showPopupCat && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-normal text-[12px]">Add Category</h2>
            <form onSubmit={handlePopupSubmitCat}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  label="Name"
                  placeholder="Name"
                  formik={formik}
                  name="name"
                  width="w-full"
                  new_width="w-full"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopupCat}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                                          rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showDeleteConfirm && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
            <h3 className="text-sm font-medium mb-4">Warning</h3>
            <p className="mb-6 text-xs">
              Are you sure you want to delete this equipment?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={cancelDelete}
                className="px-4 py-[8px] text-xs hover:bg-gray-300 rounded-md bg-[#E6F2F2] text-textColor-main"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-4 py-[8px] text-xs bg-textColor-main rounded-md text-white hover:opacity-90"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Equipments;
